import axios from "@/libs/api.request";
// 分公司应退账单
// 获取应退账单列表
export const getClientBill = params => {
  return axios.request({
    url: "/finance/branch/cod/bill/ys",
    method: "get",
    params
  });
};

// 列表明细接口
export const getDetails = params => {
  return axios.request({
    url: `/finance/branch/cod/bill/ys/details/${params.id}`,
    method: "get",
    params
  });
};

// 明细详情接口
export const getItemDetails = id => {
  return axios.request({
    url: `/finance/branch/cod/bill/ys/${id}`,
    method: "get"
  });
};

//国家货币汇率
export const getCountryCurrency = id => {
  return axios.request({
    url: `/finance/branch/cod/bill/ys/totalCountryAndRate/${id}`,
    method: "get"
  });
};
// 设置汇率并重新计算
export const saveCountryCurrency = data => {
  return axios.request({
    url: `/finance/branch/cod/bill/ys/reStatistics/${data.id}`,
    method: "post",
    data
  });
};

// 追加订单
export const apendCnbNumbers = data => {
  return axios.request({
    url: `/finance/branch/cod/bill/ys/append/${data.id}`,
    method: "post",
    data
  });
};
// 更新订单
export const updateItem = data => {
  return axios.request({
    url: `/finance/branch/cod/bill/ys/${data.id}`,
    method: "put",
    data
  });
};
// 批量核销
export const batchWriteOff = data => {
  return axios.request({
    url: `/finance/branch/cod/bill/ys/batchWriteOff`,
    method: "post",
    data
  });
};
// 取消核销
export const cancelWriteOff = id => {
  return axios.request({
    url: `/finance/branch/cod/bill/ys/cancelOff/${id}`,
    method: "post"
  });
};

// 删除接口
export const deleteItem = id => {
  return axios.request({
    url: `/finance/branch/cod/bill/ys/${id}`,
    method: "delete"
  });
};
